import { render, staticRenderFns } from "./FrequencyLineChart.vue?vue&type=template&id=0d2acb60&"
import script from "./FrequencyLineChart.vue?vue&type=script&lang=js&"
export * from "./FrequencyLineChart.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyLineChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VRow,VSelect})
